var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "url(#paint0_linear_6607_20495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21615 11.4792C7.21615 11.4792 6.8248 10.8111 6.66668 10.4731C6.47486 10.0484 6.37813 9.58689 6.38325 9.12087C6.38837 8.65486 6.49522 8.19559 6.69633 7.77517C6.8459 7.49649 7.06176 7.25891 7.32486 7.08338L11.7404 4L7.21615 11.4792ZM5.46698 14.9789C5.12611 14.3479 4.92397 13.6514 4.87412 12.936C4.81271 12.3164 4.80742 11.6926 4.85831 11.0721C4.94672 10.4851 5.1247 9.91517 5.38604 9.38218C5.38604 9.38218 5.51649 9.12721 5.58369 9.00269C5.54762 9.24048 5.54762 9.48237 5.58369 9.72017C5.66519 10.2453 5.84061 10.7515 6.10154 11.2144C8.67894 15.5964 11.7347 20.0001 11.7347 20.0001L6.85065 16.5945C6.27961 16.1607 5.80786 15.6098 5.46698 14.9789ZM17.3342 13.5268C17.1761 13.1888 16.7848 12.5208 16.7848 12.5208L12.2605 19.9999L16.6761 16.9185C16.9392 16.743 17.155 16.5054 17.3046 16.2267C17.506 15.8061 17.613 15.3464 17.6181 14.8801C17.6233 14.4137 17.5264 13.9518 17.3342 13.5268ZM18.534 9.02122C18.8749 9.65218 19.077 10.3487 19.1269 11.0641C19.1876 11.6837 19.1923 12.3075 19.1407 12.928C19.0523 13.515 18.8743 14.0849 18.613 14.6179C18.613 14.6179 18.4825 14.8729 18.4153 14.9974C18.4514 14.7596 18.4514 14.5177 18.4153 14.2799C18.3345 13.7549 18.1597 13.2488 17.8995 12.7857C15.3201 8.40371 12.2664 4 12.2664 4L17.1504 7.40556C17.7214 7.83941 18.1931 8.39026 18.534 9.02122Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6607_20495",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE82FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F6AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ens.474141e3b57200015cd05e73b1752ea0.svg";
export { ForwardRef as ReactComponent };